import { IContractPageRequest } from '../../../../model/scp/contract/request/contract-paged-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';

export type ContractSearchState = {
  typeContract: ITableResponse[];
  categoryProcess: ITableResponse[];
  parameters: IContractPageRequest;
  searchTrigger: number;
};

export enum ACTION_TYPES {
  setTypeContract = 'setTypeContract',
  setCategoryProcess = 'setCategoryProcess',
  setParameters = 'setParameters',
  updateParameter = 'updateParameter',
  triggerSearch = 'triggerSearch',
}

export const ContractSearchReducer = (state: ContractSearchState, action: any): ContractSearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setTypeContract:
      return {
        ...state,
        typeContract: payload,
      };
    case ACTION_TYPES.setCategoryProcess:
      return {
        ...state,
        categoryProcess: payload,
      };
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.triggerSearch:
      return {
        ...state,
        searchTrigger: state.searchTrigger + 1,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
